import { render, staticRenderFns } from "./DragResizeHandlerVertical.vue?vue&type=template&id=55cf8786&scoped=true&"
import script from "./DragResizeHandlerVertical.vue?vue&type=script&lang=ts&"
export * from "./DragResizeHandlerVertical.vue?vue&type=script&lang=ts&"
import style0 from "./DragResizeHandlerVertical.vue?vue&type=style&index=0&id=55cf8786&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf8786",
  null
  
)

export default component.exports